<div class="mat-typography" (keydown)="onKeyDown($event)">
  <h1 mat-dialog-title i18n>Filter Value</h1>
  <div mat-dialog-content>
    <mat-form-field appearance="fill">
      <mat-label i18n>Search Keyword</mat-label>
      <mat-chip-grid #chipGrid aria-label="Search keywords">
        <mat-chip-row
          *ngFor="let keyword of data.values"
          (removed)="remove(keyword)"
        >
          {{ keyword }}
          <button matChipRemove [attr.aria-label]="'remove ' + keyword">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      </mat-chip-grid>
      <input
        placeholder="New keyword..."
        i18n-placeholder
        #keywordInput
        [formControl]="keywordCtrl"
        [matChipInputFor]="chipGrid"
        [matAutocomplete]="auto"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="selected($event)"
      >
        <mat-option
          *ngFor="let keyword of filteredKeywords | async"
          [value]="keyword"
        >
          {{ keyword }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false" i18n>Cancel</button>
    <button mat-button [mat-dialog-close]="getParameter()" i18n>OK</button>
  </div>
</div>
